import React from 'react';

// styles
import { Wrapper, Spinner } from './LoadingSpinner.styles';

const LoadingSpinner = () => {
  return (
    <Wrapper>
      <Spinner />
    </Wrapper>
  );
};

export default LoadingSpinner;
